<div class="modal-header" id="eta-alert-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAILS_ETA_ALERT_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col-12">
            <span
                translate="NOTIFICATION_DETAILS_ETA_ALERT_MESSAGE"
                [translateParams]="{
                    notificationNo: this.notification.identifier.qmNum,
                    taskNo: this.notification.identifier.maNum,
                    duration: durationLeftInMinutes,
                }"
            >
            </span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        (click)="modalInstance.hide()"
        translate="NOTIFICATION_DETAILS_ETA_ALERT_OK"
    ></button>
</div>
